import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/linkedin': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 32c17.6 0 32 14.5 32 32.3v383.4c0 17.8-14.4 32.3-32 32.3h-384.1c-17.6 0-31.9-14.5-31.9-32.3v-383.4c0-17.8 14.3-32.3 31.9-32.3h384.1zM135.4 416h0.1v-213.8h-66.5v213.8h66.4zM102.2 173c21.3 0 38.5-17.2 38.5-38.5 0-21.2-17.3-38.5-38.5-38.5-21.3 0-38.5 17.3-38.5 38.5s17.2 38.5 38.5 38.5zM384.3 416v-117.2c0-57.6-12.5-101.9-79.7-101.9-32.3 0-54 17.7-62.9 34.5h-0.9v-29.2h-63.7v213.8h66.4v-105.8c0-27.9 5.3-54.9 39.9-54.9 34 0 34.5 31.9 34.5 56.7v104h66.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linkedin.js
// module id = 916
// module chunks = 0